import React, { useCallback } from 'react';

import { GridActions } from 'src/components/common/GridActions';
import { GridActionsGenerateItem } from 'src/components/common/GridActions/helpers';
import { DonationPageListItemType } from 'src/models/DonationPage/List';
import { Enums } from 'src/models/enums';
import { DonationPageListModalsType } from 'src/pages/DonationPageList/_settings';
import { useTHelper } from 'src/utils/i18n';
import { UiHoverTooltip } from 'src/components/UI/HoverTooltip';
import { CustomDropdownListElement } from 'src/components/common/CustomDropdownListElement';
import styles from './styles.module.scss';

type Props = {
  item: DonationPageListItemType;
  setModalData: (data: { item: DonationPageListItemType | null; modalName: DonationPageListModalsType | null }) => void;

  simple?: boolean;
  onClickCopy?: () => void;
};

export const DonationPageListActionsBtn: React.FC<Props> = ({ item, simple, setModalData, onClickCopy }: Props) => {
  const tHelper = useTHelper('donationPageList.actions');

  const actions = useCallback(
    (item: DonationPageListItemType) => {
      const commonFn = (modalName: DonationPageListModalsType) => () => {
        setModalData({
          modalName,
          item,
        });
      };

      const copyFn = onClickCopy && (() => onClickCopy);

      return (
        <>
          {(item.CanTurnOff || item.ShowPaymentProcessingTooltip) && (
            <UiHoverTooltip
              text={tHelper('turnOnDisabledTooltip')}
              place="left"
              render={item.ShowPaymentProcessingTooltip}
            >
              <CustomDropdownListElement
                onClick={commonFn('turnonoff')}
                className={styles.menuItem}
                active={!item.ShowPaymentProcessingTooltip}
              >
                {tHelper(
                  item.DonationPageDisplayingStatusCode === Enums.campaigns.StatusCode.Off ? 'turnOn' : 'turnOff'
                )}
              </CustomDropdownListElement>
            </UiHoverTooltip>
          )}
          {item.CanCopy &&
            GridActionsGenerateItem({
              actionName: 'copy',
              tHelper,
              onClick: copyFn || commonFn,
              icon: 'content_copy',
            })}
          {item.CanArchive &&
            item.IsHomePageSelectedDonationPage &&
            GridActionsGenerateItem({
              actionName: 'cantarchive',
              tHelper,
              onClick: commonFn,
              icon: 'archive',
            })}
          {item.CanArchive &&
            !item.IsHomePageSelectedDonationPage &&
            GridActionsGenerateItem({
              actionName: 'archive',
              tHelper,
              onClick: commonFn,
              icon: 'archive',
            })}
          {item.CanUnarchive &&
            GridActionsGenerateItem({
              actionName: 'unarchive',
              tHelper,
              onClick: commonFn,
            })}
          {item.CanDelete &&
            GridActionsGenerateItem({
              actionName: 'delete',
              tHelper,
              onClick: commonFn,
            })}
        </>
      );
    },
    [onClickCopy, setModalData, tHelper]
  );

  return <GridActions simple={simple}>{actions(item)}</GridActions>;
};
